/* eslint-disable */
import React, { useMemo, useState } from "react";
import "./ParentHeader.css";

function ChevronDownIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      className="pph-chevron"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

function ChildMiniIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      className="pph-chip-icon"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="8" r="3.2" />
      <path d="M5.5 19c1.5-3.1 4-4.7 6.5-4.7s5 1.6 6.5 4.7" />
    </svg>
  );
}

function getHeaderMeta(title, activeChild) {
  const childName = activeChild?.name || "your child";
  const year =
    activeChild?.year ||
    activeChild?.yearGroup ||
    activeChild?.className ||
    "";

  if (title === "Home") {
    return {
      eyebrow: "",
      subtitle: year ? `${childName} • ${year}` : childName,
    };
  }

  if (title === "Attendance") {
    return {
      eyebrow: "",
      subtitle: year ? `${childName} • ${year}` : childName,
    };
  }

  if (title === "Updates") {
    return {
      eyebrow: "",
      subtitle: year ? `${childName} • ${year}` : childName,
    };
  }

  if (title === "Notifications") {
    return {
      eyebrow: "",
      subtitle: "Recent alerts",
    };
  }

  if (title === "Profile") {
    return {
      eyebrow: "",
      subtitle: "Security and preferences",
    };
  }

  if (title === "Reports") {
    return {
      eyebrow: "",
      subtitle: "Monthly attendance reports",
    };
  }

  if (title === "Absence") {
    return {
      eyebrow: "",
      subtitle: "Report a school absence",
    };
  }

  return {
    eyebrow: "",
    subtitle: "",
  };
}

export default function ParentHeader({
  title = "Home",
  childOptions = [],
  activeChild = null,
  activeChildId = "",
  onChildChange,
  rightAction = null,
}) {
  const [pickerOpen, setPickerOpen] = useState(false);

  const meta = useMemo(
    () => getHeaderMeta(title, activeChild),
    [title, activeChild]
  );

  const safeChildren = Array.isArray(childOptions)
    ? childOptions.filter(Boolean)
    : [];

  const resolvedChild =
    activeChild ||
    safeChildren.find(
      (item) => String(item?.id || "") === String(activeChildId || "")
    ) ||
    safeChildren[0] ||
    null;

  const childName = resolvedChild?.name || "Select child";
  const childYear =
    resolvedChild?.year ||
    resolvedChild?.yearGroup ||
    resolvedChild?.className ||
    "";

  function handleSelect(nextId) {
    if (typeof onChildChange === "function") {
      onChildChange(nextId);
    }
    setPickerOpen(false);
  }

  return (
    <>
      <header className="pph-wrap">
        <div className="pph-shell">
          <div className="pph-main-row pph-main-row--compact">
            <div className="pph-copy">
              {meta.eyebrow ? (
                <p className="pph-eyebrow">{meta.eyebrow}</p>
              ) : null}

              <h1 className="pph-title">{title}</h1>

              {meta.subtitle ? (
                <p className="pph-subtitle">{meta.subtitle}</p>
              ) : null}
            </div>

            <div className="pph-header-actions">
              {rightAction ? (
                <div className="pph-right">{rightAction}</div>
              ) : null}

              <button
                type="button"
                className={`pph-child-pill pph-child-pill--compact ${
                  pickerOpen ? "open" : ""
                }`}
                onClick={() => setPickerOpen((prev) => !prev)}
                disabled={!safeChildren.length}
              >
                <span className="pph-child-pill-main">
                  <span className="pph-child-avatar">
                    <ChildMiniIcon />
                  </span>

                  <span className="pph-child-copy">
                    <span className="pph-child-label">Viewing child</span>
                    <span className="pph-child-name">
                      {childName}
                      {childYear ? <small>{childYear}</small> : null}
                    </span>
                  </span>
                </span>

                <ChevronDownIcon />
              </button>
            </div>
          </div>
        </div>
      </header>

      {pickerOpen ? (
        <div
          className="pph-picker-backdrop"
          onClick={() => setPickerOpen(false)}
        >
          <div
            className="pph-picker-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pph-picker-handle" />

            <div className="pph-picker-head">
              <p className="pph-picker-eyebrow">Child selector</p>
              <h3 className="pph-picker-title">Choose child</h3>
              <p className="pph-picker-subtitle">
                Switch the dashboard context without leaving the page.
              </p>
            </div>

            <div className="pph-picker-list">
              {safeChildren.length ? (
                safeChildren.map((child) => {
                  const id =
                    child?.id || child?.studentId || child?.docId || "";
                  const selected =
                    String(id) ===
                    String(activeChildId || resolvedChild?.id || "");
                  const year =
                    child?.year ||
                    child?.yearGroup ||
                    child?.className ||
                    "Year group";

                  return (
                    <button
                      key={id}
                      type="button"
                      className={`pph-picker-item ${
                        selected ? "selected" : ""
                      }`}
                      onClick={() => handleSelect(id)}
                    >
                      <span className="pph-picker-avatar">
                        <ChildMiniIcon />
                      </span>

                      <span className="pph-picker-copy">
                        <strong>{child?.name || "Child"}</strong>
                        <small>{year}</small>
                      </span>

                      {selected ? (
                        <span className="pph-picker-check">Current</span>
                      ) : null}
                    </button>
                  );
                })
              ) : (
                <div className="pph-picker-empty">
                  No linked child available yet.
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}